module.exports = __webpack_public_path__ + "img/assign_qc.d1448cb9.svg";